export const CARD_IMG_BASE = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';

/** Turn a card code into an image path */
export const cardSrc = (code) => {
  if (!code || code === '1' || code === '0') return `${CARD_IMG_BASE}/1.png`;
  return `${CARD_IMG_BASE}/${code}.png`;
};

/** Split a comma-separated card string into an array of codes */
export const parseCards = (cardString) =>
  cardString ? cardString.split(',').map((c) => c.trim()).filter(Boolean) : [];
